import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { AbstractEffects } from "app/shared/utils/abstract-effects";
import { MessageService } from "primeng/api";
import { DeleteFailure, EntityActionTypes, ofEntityType } from "@briebug/ngrx-auto-entity";
import { tap } from "rxjs/operators";
import { SousDocumentation } from "./sousdocumentation.model";

@Injectable()
export class SousDocumentationEffects extends AbstractEffects {
    constructor(
        _actions$: Actions,
        _messageService: MessageService,
        _translateService: TranslateService,
        _router: Router
    ) {
        super(
            SousDocumentation,
            _actions$,
            _messageService,
            _router,
            _translateService,
            "SOUSDOCUMENTATION"
        );
    }
    deleteFailure$ = createEffect(
        () =>
            this._actions$.pipe(
                ofEntityType(
                    SousDocumentation,
                    EntityActionTypes.DeleteFailure
                ),
                tap((action: DeleteFailure<SousDocumentation>) => {
                    this._translateService
                        .get(["App", "AUDIT"])
                        .subscribe((msgs) => {
                            this._messageService.add({
                                severity: "error",
                                summary: msgs.App.SUMMARY_ERROR,
                                detail: msgs.AUDIT.MSG,
                            });
                        });
                })
            ),
        { dispatch: false } //je peux pas la déclencher seule
    );
}
